/**
 * Create an accurate interval that does not skew over time.
 * @param  {function}   func            Function to call ever interval ms
 * @param  {number}     interval        Interval (in ms) with which to call func
 * @return {Object}                     Object with clear method
 */
export function setAccurateInterval(func, interval) {

  let clear, nextAt, timeout, wrapper, now;

  now = new Date().getTime();

  nextAt = now;

  timeout = null;

  wrapper = function () {
    nextAt += interval;
    timeout = setTimeout(wrapper, nextAt - new Date().getTime());
    func();
  };

  clear = function clear() {
    return clearTimeout(timeout);
  };

  timeout = setTimeout(wrapper, nextAt - new Date().getTime());

  return {
    clear: clear
  };

};



// WEBPACK FOOTER //
// ./src/tools/interval.js